import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import * as moment from 'moment';

@Directive({
    selector: '[preserveTime]'
})
export class PreserveTimeDirective {
    constructor(private ngControl: NgControl) { }

    @HostListener('dateChange', ['$event'])
    onDateChange(event: any) {
        const newValue = event.value;
        const currentControlValue = this.ngControl.control?.value;

        if (newValue && currentControlValue) {
            // Sử dụng UTC tuyệt đối theo ý muốn của bạn
            const mNew = moment.utc(newValue);
            const mCurrent = moment.utc(currentControlValue);

            // Giữ lại các thành phần giờ/phút/giây từ giá trị UTC hiện tại
            mNew.hour(mCurrent.hour());
            mNew.minute(mCurrent.minute());
            mNew.second(mCurrent.second());
            mNew.millisecond(mCurrent.millisecond());

            // Cập nhật lại control bằng đối tượng Moment ở chế độ UTC
            this.ngControl.control?.setValue(mNew, { emitEvent: false });
        }
    }

    @HostListener('dateInput', ['$event'])
    onDateInput(event: any) {
        this.onDateChange(event);
    }
}
